import React from "react";

import { useTranslation } from "next-i18next";

import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";

import PanIcon from "~public/icons/Pan/Pan.svg";

export const AddFavouriteDishesSection = (props: any): JSX.Element => {
  const { t } = useTranslation("searchpage");
  const theme = useTheme();
  const isGreaterThanTablet = useMediaQuery(theme.breakpoints.up("md"));
  return (
    <>
      {isGreaterThanTablet && (
        <div
          style={{
            marginBottom: "-10px",
            width: "100%"
          }}>
          <img
            alt="Mushroom slicing"
            src={"/images/searchpage/desktop-picture-one.webp"}
            style={{ width: "100%", display: "block" }}
          />
        </div>
      )}
      <Box
        position={"relative"}
        sx={{
          px: 2,
          py: 4,
          bgcolor: "green.main"
        }}>
        <Box
          sx={{
            maxWidth: { md: "1180px" },
            width: { md: "100%" },
            margin: { md: "0 auto" },
            display: "flex",
            gap: 1.25,
            flexDirection: "column",
            alignItems: "center",
            "&>:nth-of-type(odd)": {
              alignSelf: "start"
            },
            "&>:nth-of-type(even)": {
              alignSelf: "end"
            }
          }}>
          <Typography
            zIndex={1}
            sx={{
              alignSelf: "start",
              fontSize: { xs: 28, md: 96 },
              color: { xs: "#475467", md: "#42210A" }
            }}
            fontWeight={500}
            // fontSize={28}
            // color={"#475467"}
          >
            {t("add-your-section.text1")}
          </Typography>
          <Typography
            zIndex={1}
            sx={{
              alignSelf: "end",
              fontSize: { xs: 28, md: 96 },
              color: { xs: "#475467", md: "#42210A" },
              width: { md: "fit-content" }
            }}
            fontWeight={500}
            // fontSize={28}
            // color={"#475467"}
            textTransform={"lowercase"}>
            <Box component={"span"} color={"white.main"}>
              {t("add-your-section.text2") + " "}
            </Box>
            {t("add-your-section.text3")}
          </Typography>
          <Typography
            zIndex={1}
            sx={{
              alignSelf: "end",
              fontSize: { xs: 28, md: 96 },
              color: { xs: "#475467", md: "#42210A" }
            }}
            fontWeight={500}
            // fontSize={28}
            // color={"#475467"}
          >
            {t("add-your-section.text4")}
          </Typography>
          <Box
            position={"absolute"}
            // left={-20}
            sx={{ left: { xs: -20, md: 219 }, top: { xs: 40, md: 70 } }}
            zIndex={0}>
            <PanIcon
              style={{
                width: isGreaterThanTablet ? 200 : 90,
                height: isGreaterThanTablet ? 305 : 115,
                zIndex: 0
              }}
            />
          </Box>
          <Box
            position={"absolute"}
            // right={0}
            sx={{ right: { xs: 0, md: 152 }, top: { xs: 70, md: 170 } }}
            zIndex={0}>
            <PanIcon
              style={{
                width: isGreaterThanTablet ? 239 : 90,
                height: isGreaterThanTablet ? 305 : 115,
                zIndex: 0
              }}
            />
          </Box>
        </Box>
      </Box>

      {isGreaterThanTablet && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center"
          }}>
          <img
            alt="Mushroom slicing"
            src={"/images/searchpage/desktop-picture-two.webp"}
            width={1920}
            height={512}
            style={{ width: "100%", display: "block" }}
          />
        </Box>
      )}
    </>
  );
};
